import { BreakpointObserver, Breakpoints, MediaMatcher } from '@angular/cdk/layout';
import { isPlatformBrowser, DOCUMENT, CommonModule, isPlatformServer } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, inject, Inject, Input, makeStateKey, OnDestroy, OnInit, Output, PLATFORM_ID, ViewChild } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { Category, ItemService } from '../../pages/item-detail/item-detail.service';
import { APPHOST } from '../../app.component';
import { Router, RouterModule } from '@angular/router';
import { PrerenderDataService } from '../../prerender-data.service';
import { WelcomeScreenMedia, WelcomeScreenMediaService } from './welcome-screen-media.service';

@Component({
  selector: 'app-initial-welcome-screen-solo',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './initial-welcome-screen.component.html',
  styleUrls: ['./initial-welcome-screen.component.scss', './glass.scss'],
})
export class InitialWelcomeScreenSoloComponent implements AfterViewInit, OnInit, OnDestroy {
  WELCOME_SHORCUTS = makeStateKey<any>('WELCOME_SHORCUTS');
  WELCOME_HERO = makeStateKey<WelcomeScreenMedia>('WELCOME_HERO');

  destroyed = new Subject<void>();
  showWelcomeScreen: boolean = false;
  @Output() closeWelcomeScreen = new EventEmitter<void>();
  private readonly localMediaFallback: WelcomeScreenMedia[] = [
    { id: 'local-1', index: 1, characterImage: '1.png', backgroundImage: '1.1.jpg' },
    { id: 'local-2', index: 2, characterImage: '2.png', backgroundImage: '1.2.jpg' },
    { id: 'local-3', index: 3, characterImage: '3.png', backgroundImage: '1.1.jpg' },
    { id: 'local-4', index: 4, characterImage: '4.png', backgroundImage: '1.2.jpg' },
    { id: 'local-5', index: 5, characterImage: '5.png', backgroundImage: '1.1.jpg' },
  ];
  
  selectedCharacterImage: string = '';
  selectedBackgroundImage: string = '';

  cats: Category[] = [];

  displayNameMap = new Map([
    [Breakpoints.XSmall, 'XSmall'],
    [Breakpoints.Small, 'Small'],
    [Breakpoints.Medium, 'Medium'],
    [Breakpoints.Large, 'Large'],
    [Breakpoints.XLarge, 'XLarge'],
  ]);
  isMobile: boolean = true;
  cat1: Category = { label: '', icon: '', slug: '', showNewState: false, mainNavItem: { id: '', label: '' }, filters: [], menuOrder: 0 };
  cat2: Category = { label: '', icon: '', slug: '', showNewState: false, mainNavItem: { id: '', label: '' }, filters: [], menuOrder: 0 };
  cat3: Category = { label: '', icon: '', slug: '', showNewState: false, mainNavItem: { id: '', label: '' }, filters: [], menuOrder: 0 };

  private itemService = inject(ItemService);
  private prerenderDataService = inject(PrerenderDataService);
  private welcomeScreenMediaService = inject(WelcomeScreenMediaService);

  constructor(@Inject(DOCUMENT) private document: Document,
    private breakpointObserver: BreakpointObserver,
    private media: MediaMatcher, private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object) {



    if (isPlatformBrowser(this.platformId)) {

      const urlObject = new URL(window.location.href);
      if (urlObject.pathname.includes('/home') || urlObject.pathname === ('/')) {
        this.showWelcomeScreen = true;
      } else {
        this.showWelcomeScreen = false;
        this.close()
      }


      const CATS = this.prerenderDataService.getPreloadedData(this.WELCOME_SHORCUTS)
      if (CATS && CATS.length > 0) {
        this.cat1 = CATS[0];
        this.cat2 = CATS[1];
        this.cat3 = CATS[2];
      } else {
        this.itemService.getAllCats().subscribe(w => {
          this.prerenderDataService.setPreloadedData(this.WELCOME_SHORCUTS, [w.find(e => e.menuOrder === 1), w.find(e => e.menuOrder === 2), w.find(e => e.menuOrder === 3)]);
          const CATS = this.prerenderDataService.getPreloadedData(this.WELCOME_SHORCUTS)
          if (CATS && CATS.length > 0) {
            this.cat1 = CATS[0];
            this.cat2 = CATS[1];
            this.cat3 = CATS[2];
          }
        })
      }


    } else if (isPlatformServer(this.platformId)) {
      this.itemService.getAllCats().subscribe(w => {
        this.prerenderDataService.setPreloadedData(this.WELCOME_SHORCUTS, [w.find(e => e.menuOrder === 1), w.find(e => e.menuOrder === 2), w.find(e => e.menuOrder === 3)]);

      })
    }



    // alert(router.url)
    if (router.url.includes('home') || router.url === ('/')) {
    } else {
      this.close()

    }

    this.breakpointObserver
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge,
      ])
      .pipe(takeUntil(this.destroyed))
      .subscribe(result => {
        const mobileQuery = this.media.matchMedia('(max-width: 600px)');
        if (mobileQuery.matches) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      });

  }
  close() {
    this.closeWelcomeScreen.emit();
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.loadRandomWelcomeScreenMedia();
    }
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {

      const wallpaper = document.getElementById('wallpaper');
      const wavatar = document.getElementById('wavatar');

      window.addEventListener('mousemove', (e) => {
        const x = (e.clientX / window.innerWidth - 0.5) * 2;
        const y = (e.clientY / window.innerHeight - 0.5) * 2;

        if (wallpaper) {
          const _x = -(x * 15);
          const _y = -(y * 15);
          wallpaper.style.transform = `scale(1.08) translate(${_x}px,${_y}px)`;

        }
        if (wavatar) {
          const _x = -(x * 60);
          const _y = (y * 20);
          wavatar.style.transform = `translate(${x * 80}px, ${y * 80}px) rotate3d(0, 1, 0, ${_y}deg) scale(1.05) `;
        }
      });
    }

  }
  private loadRandomWelcomeScreenMedia(): void {
    this.welcomeScreenMediaService
      .getWelcomeScreenMedia(0, 100)
      .pipe(takeUntil(this.destroyed))
      .subscribe({
        next: (records) => {
          this.pickRandomMedia(records.length > 0 ? records : this.localMediaFallback);
        },
        error: () => {
          this.pickRandomMedia(this.localMediaFallback);
        },
      });
  }

  private pickRandomMedia(records: WelcomeScreenMedia[]): void {
  
    const randomRecord = records[Math.floor(Math.random() * records.length)];
    this.selectedCharacterImage = this.toAssetPath(randomRecord?.characterImage);
    this.selectedBackgroundImage = this.toAssetPath(randomRecord?.backgroundImage, '1920', '0.8f');
  }

  private toAssetPath(imageName?: string, width?: string, quality?: string): string {
    if (!imageName) {
      return '';
    }
    if(imageName.startsWith('api/image')){
      if (width && quality) {
        let path = imageName.replace('api/image', `api/image/thumb/${width}/${quality}`);
        return  'https://softnetcomputers.lk/'+path;
      }
      return  'https://softnetcomputers.lk/'+imageName;
    }

    if (imageName.startsWith('http://') || imageName.startsWith('https://') || imageName.startsWith('assets/')) {
      return imageName;
    }

    return `assets/welcome_screens/${imageName}`;
  }

  getIcon(i: string): string {
    i = APPHOST + '/' + i
    return i.replace('image', 'image/thumb/40/0.6f');
  }
}
